export default "__VITE_ASSET__672bd41c__"